import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'

export const smsService = {
    sendSMS,
    statisticsSms,
}

function sendSMS(data) {
    const url = '/api/sms'

    return httpClient.post(url, data).then(handleResponseAsync)
}

function statisticsSms(data) {
    const url = '/api/sms/statistics'

    return httpClient.get(url).then(handleResponseAsync)
}
